import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  href?: string;
  id?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = '¡SÍ! QUIERO QUE MI HIJO SEA UN MINI-CEO',
  subtext = 'Acceso instantáneo a la descarga digital después del pago',
  className = '',
  href = '#checkout-cta',
  id,
  onClick
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const handleClick = (e: React.MouseEvent) => {
    if (isExternal) {
      // Fire Meta Pixel AddToCart event before redirecting to Shopify
      trackAddToCart({
        content_name: 'Mini-CEO Blueprint',
        content_category: 'Digital Product',
        content_ids: ['mini-ceo-blueprint'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    } else if (href.startsWith('#')) {
      e.preventDefault();
      const target = document.getElementById(href.slice(1));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
    onClick?.();
  };
  return <motion.a id={id} href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative flex flex-col items-center justify-center w-full max-w-xl mx-auto bg-orange hover:bg-orange-light text-white rounded-xl p-4 sm:p-6 shadow-[0_8px_30px_rgb(242,101,34,0.3)] transition-colors cursor-pointer no-underline scroll-mt-24 ${className}`} data-id="element-71">
      <div className="flex items-center gap-3 text-lg sm:text-xl md:text-2xl font-heading font-bold text-center" data-id="element-72">
        <span data-id="element-73">{text}</span>
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-74" />
      </div>
      {subtext && <span className="mt-2 text-sm sm:text-base font-body font-medium opacity-90 text-center" data-id="element-75">
          {subtext}
        </span>}
    </motion.a>;
}